import Animations from './modules/Animations'
import ContactForm from './modules/ContactForm'
import Sliders from './modules/Sliders'

export default class Main {
  constructor() {
    this.init()
  }

  init() {
    Sliders.init()

    window.addEventListener('load', () => {
      Animations.init()
      ContactForm.init()
    })
  }
}

const main = new Main()
